import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AuthPage } from './pages/AuthPage';
import { BonusGamesPage } from './pages/BonusGamesPage';
import { BonusesPage } from './pages/BonusesPage';
import { CampaignPage } from './pages/CampaignPage';
import { CashierPage } from './pages/CashierPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { GameDetailPage } from './pages/GameDetailPage';
import { GamesPage } from './pages/GamesPage';
import { PlayPage } from './pages/PlayPage';
import { GoogleCallbackPage } from './pages/GoogleCallbackPage';
import { TelegramCallbackPage } from './pages/TelegramCallbackPage';
import { HomePage } from './pages/HomePage';
import { MenuPage } from './pages/MenuPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { PhoneAuthPage } from './pages/PhoneAuthPage';
import { ProfilePage } from './pages/ProfilePage';
import { ProvidersPage } from './pages/ProvidersPage';
import { ReferralPage } from './pages/ReferralPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { RulesPage } from './pages/RulesPage';
import { SecurityPage } from './pages/SecurityPage';
import { SettingsPage } from './pages/SettingsPage';
import { SportsPage } from './pages/SportsPage';
import { SupportPage } from './pages/SupportPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { VipPage } from './pages/VipPage';
import { WalletPage } from './pages/WalletPage';

/** Staging-only wallet probe — never ship route on production builds. */
const StagingWalletConnectPage =
  import.meta.env.VITE_STAGING_WALLET_PROBE === 'true'
    ? lazy(() =>
        import('./pages/StagingWalletConnectPage').then((m) => ({
          default: m.StagingWalletConnectPage,
        })),
      )
    : null;

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="games" element={<GamesPage />} />
        <Route path="games/:gameId" element={<GameDetailPage />} />
        <Route path="play/:gameId" element={<PlayPage />} />
        <Route path="campaigns/:slug" element={<CampaignPage />} />
        <Route path="providers" element={<ProvidersPage />} />
        <Route path="sports" element={<SportsPage />} />
        <Route path="bonuses" element={<BonusesPage />} />
        <Route path="bonus-games" element={<BonusGamesPage />} />
        <Route path="vip" element={<VipPage />} />
        <Route path="referral" element={<ReferralPage />} />
        <Route path="cashier" element={<CashierPage />} />
        <Route path="wallet" element={<WalletPage />} />
        {StagingWalletConnectPage ? (
          <Route
            path="staging-wallet-connect"
            element={
              <Suspense fallback={null}>
                <StagingWalletConnectPage />
              </Suspense>
            }
          />
        ) : null}
        <Route path="profile" element={<ProfilePage />} />
        <Route path="menu" element={<MenuPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="qaydalar" element={<RulesPage />} />
        <Route path="qaydalar/:categoryId" element={<RulesPage />} />
        <Route path="rules" element={<RulesPage />} />
        <Route path="rules/:categoryId" element={<RulesPage />} />
        <Route path="auth/forgot" element={<ForgotPasswordPage />} />
        <Route path="auth/reset-password" element={<ResetPasswordPage />} />
        <Route path="auth/verify-email" element={<VerifyEmailPage />} />
        <Route path="auth/phone" element={<PhoneAuthPage />} />
        <Route path="auth/google/callback" element={<GoogleCallbackPage />} />
        <Route path="auth/telegram/callback" element={<TelegramCallbackPage />} />
        <Route path="auth/:mode" element={<AuthPage />} />
        <Route path="home" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
